import { useState } from 'react';
import { api } from '../../api';
import Modal from '../../components/Modal';
import PhotoUploader from './PhotoUploader';

// Resolve a call: Completed / Cancelled, reason, notes, photos. Shared by
// the queue card and the call detail page (phone drivers resolve from the
// detail page's pinned action). Renders through Modal, so on the phone it
// is a bottom sheet with the submit pinned above the safe area.
// ===== RESOLVE CALL MODAL =====
export default function ResolveCallModal({ call, resolutionReasons, onClose, onResolved }) {
  const [type, setType] = useState('completed');
  const [reasonId, setReasonId] = useState('');
  const [notes, setNotes] = useState('');
  const [photos, setPhotos] = useState([]);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setSubmitting(true);

    const fd = new FormData();
    fd.append('resolution_type', type);
    fd.append('resolution_reason_id', reasonId);
    fd.append('resolution_notes', notes);
    for (const file of photos) fd.append('photos', file);

    try { await api.resolveCall(call.id, fd); onResolved(); }
    catch (err) { setError(err.message); }
    setSubmitting(false);
  }

  return (
    <Modal title={`Resolve Call #${call.id}`} onClose={onClose}>
      {error && <div className="alert alert-error">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Resolution Type</label>
          <div className="radio-group">
            <label><input type="radio" value="completed" checked={type==='completed'} onChange={e=>setType(e.target.value)} /> Completed</label>
            <label><input type="radio" value="cancelled" checked={type==='cancelled'} onChange={e=>setType(e.target.value)} /> Cancelled</label>
          </div>
        </div>
        <div className="form-group">
          <label>Resolution Reason</label>
          <select value={reasonId} onChange={e => setReasonId(e.target.value)} required>
            <option value="">Select reason...</option>
            {resolutionReasons.map(r => <option key={r.id} value={r.id}>{r.name}</option>)}
          </select>
        </div>
        <div className="form-group">
          <label>Notes (optional)</label>
          <textarea value={notes} onChange={e => setNotes(e.target.value)} rows={2} />
        </div>
        <div className="form-group">
          <label>Photos (optional)</label>
          <PhotoUploader files={photos} onChange={setPhotos} />
        </div>
        <div className="modal-actions">
          <button type="button" className="btn btn-muted" onClick={onClose}>Cancel</button>
          <button type="submit" className="btn btn-success" disabled={submitting}>
            {submitting ? 'Resolving...' : 'Resolve Call'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
